import { LogOut } from 'lucide-react';
import { useAuth } from 'react-oidc-context';

export const NavBarUser = () => {
  const auth = useAuth();

  const clickLogout = async (e: any) => {
    e.preventDefault();
    await auth.signoutRedirect();
  };

  const firstName = (auth.user?.profile['preferred_name'] as string) ?? auth.user?.profile.given_name;

  return (
    <nav className="flex flex-row">
      <div className="flex flex-row items-center justify-between gap-x-5 text-sm leading-6">
        {firstName} {auth.user?.profile.family_name}
        <button onClick={clickLogout}>
          <LogOut aria-label="Logout" className="h-5 w-5" />
          <span className="sr-only">Logout</span>
        </button>
      </div>
    </nav>
  );
};
